import axios from 'axios';

import { API_URL } from 'constants'

export function getTasks() {
  return axios.get(`${API_URL}/api/v1/tasks.json`, { withCredentials: true })
    .then(response => response.data)
    .catch((response) => {
      console.log(response);

      return [];
    })
}

export function getTask(id) {
  return axios.get(`${API_URL}/api/v1/tasks/${id}.json`, { withCredentials: true })
    .then(response => response.data)
    .catch((response) => {
      console.log(response);

      return [];
    })
}
